import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "./translations";

const STORAGE_KEY = "el-sol-lang";
const DEFAULT_LANG = "en";

const I18nContext = createContext({
  lang: DEFAULT_LANG,
  setLang: () => {},
  toggle: () => {},
  t: (key) => key,
});

function resolve(obj, path) {
  return path.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === "es" || saved === "en" ? saved : DEFAULT_LANG;
  });

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, lang);
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    if (next === "en" || next === "es") setLangState(next);
  }, []);

  const toggle = useCallback(() => {
    setLangState((l) => (l === "en" ? "es" : "en"));
  }, []);

  const t = useCallback(
    (key) => {
      const dict = translations[lang] || translations[DEFAULT_LANG];
      const value = resolve(dict, key);
      if (value === undefined) {
        const fallback = resolve(translations[DEFAULT_LANG], key);
        return fallback !== undefined ? fallback : key;
      }
      return value;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useT() {
  return useContext(I18nContext);
}
